<div class="patient-registration-container view-body">
  <div class="page-title">
    <h2>Patient Registration Form<br><span>for PatientGO® Services</span></h2>
  </div>

  <form [formGroup]="patientRegistrationForm" (submit)="createPatientRegistration()">
    <input #uploadRegistrationFormInput (change)="preview(uploadRegistrationFormInput.files)" accept='image/*,.pdf' style="display: none;"
           type="file">
    <input #uploadBankDetailsInput (change)="previewBankDetails(uploadBankDetailsInput.files)" accept='image/*,.pdf' style="display: none;"
           type="file">
    <input #uploadMiscImageInput (change)="previewMiscAttachments(uploadMiscImageInput.files)" accept='image/*,.pdf' style="display: none;"
           type="file" multiple>

    <div class="content-panel">
      <h2>Trial & Site Information</h2>
      <div class="form-row">
        <div class="form-field">
          <label for="trialCode">Public Trial Code <sup>*</sup></label>
          <app-dropdown-input #trialSelect [options]="trialOptions" [parentForm]="patientRegistrationForm"
                              name="trialId" placeholder="Select Trial..."></app-dropdown-input>
          <span *ngIf="patientRegistrationForm.controls.trialId.errors?.required && showFormErrors"
                class="error-label">
            Trial is required.
          </span>
        </div>
        <div class="form-field">
          <label for="siteNumber">Site Number <sup>*</sup></label>
          <app-dropdown-input [disabled]="!patientRegistrationForm.get('trialId').value" #siteSelect
                              [options]="siteOptions[patientRegistrationForm.get('trialId').value]"
                              [parentForm]="patientRegistrationForm" name="siteId" placeholder="Select Site..."></app-dropdown-input>
          <span *ngIf="patientRegistrationForm.controls.siteId.errors?.required && showFormErrors"
                class="error-label">
            Site is required.
          </span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          <label for="investigatorName">Investigator Name <sup>*</sup></label>
          <input type="text" id="investigatorName" class="form-control" formControlName="investigatorName">
          <span *ngIf="patientRegistrationForm.controls.investigatorName.errors?.required && showFormErrors"
                class="error-label">
            Investigator name is required.
          </span>
        </div>
        <div class="form-field">
          <label for="formFillerEmail">Your Email (person completing this form) <sup>*</sup></label>
          <input type="text" id="formFillerEmail" class="form-control" formControlName="formFillerEmail">
          <span *ngIf="patientRegistrationForm.controls.formFillerEmail.errors?.required && showFormErrors"
                class="error-label">
            Your email is required.
          </span>
        </div>
      </div>
    </div>

    <div class="content-panel">
      <h2>Patient Details</h2>
      <div class="form-row">
        <div class="form-field">
          <label for="patientFirstName">Patient First Name <sup>*</sup></label>
          <input type="text" id="patientFirstName" class="form-control" formControlName="patientFirstName">
          <span *ngIf="patientRegistrationForm.controls.patientFirstName.errors?.required && showFormErrors"
                class="error-label">
            Patient first name is required.
          </span>
        </div>
        <div class="form-field">
          <label for="patientLastName">Patient Last Name <sup>*</sup></label>
          <input type="text" id="patientLastName" class="form-control" formControlName="patientLastName">
          <span *ngIf="patientRegistrationForm.controls.patientLastName.errors?.required && showFormErrors"
                class="error-label">
            Patient last name is required.
          </span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          <label for="patientNumber">Subject ID <sup>*</sup></label>
          <input type="text" id="patientNumber" class="form-control" formControlName="patientNumber">
          <span *ngIf="patientRegistrationForm.controls.patientNumber.errors?.required && showFormErrors"
                class="error-label">
            Subject ID is required.
          </span>
        </div>
        <div class="form-field">
          <label for="email">Email Address <sup>*</sup></label>
          <input type="email" id="email" class="form-control" formControlName="email">
          <span *ngIf="patientRegistrationForm.controls.email.errors?.required && showFormErrors"
                class="error-label">
            Email is required.
          </span>
        </div>
      </div>
      @if (subjectIdWarning) {
       <div style="margin-bottom: 20px;">
         <pgo-callout variant="warning" size="sm" [title]="subjectIdWarning">
           <div class="subject-id-confirm" style="background: #fff; border-radius: 4px; padding: 10px; margin-top: 5px;">
             <app-checkbox label="I understand and wish to continue" textSize="sm"
                           [(ngModel)]="subjectIdWarningAcknowledged" [ngModelOptions]="{standalone: true}">
             </app-checkbox>
           </div>
         </pgo-callout>
       </div>
      }
      <div class="form-row">
        <div class="form-field">
          <label for="language">Patient Language <sup>*</sup></label>
          <app-dropdown-input #languageSelect [options]="languageOptions" [parentForm]="patientRegistrationForm"
                              name="language" placeholder="Select Language..." [filterable]="true"></app-dropdown-input>
          <span *ngIf="patientRegistrationForm.controls.language.errors?.required && showFormErrors" class="error-label">Language is required.</span>
        </div>
        <div class="form-field">
          <label for="screeningDate">Screening Date (if applicable)</label>
          <app-datepickerv2-input [parentForm]="patientRegistrationForm" controlName="screeningDate"></app-datepickerv2-input>
        </div>
        <div class="form-field">
          <label for="cardNumber">PatientGO Card Number</label>
          <input type="text" id="cardNumber" class="form-control" formControlName="cardNumber">
        </div>
      </div>
      <div class="form-row">
        <div class="form-field full-width">
          <label for="comments">Comments</label>
          <textarea id="comments" class="form-control" formControlName="comments" rows="3"></textarea>
        </div>
      </div>
    </div>

    <div class="attachments-row">
      <div class="content-panel">
        <h2 class="required">Signed Registration Form</h2>
        <div class="expense-add-images">
          <ul class="images">
            <li *ngIf="attachment">
              <ng-container *ngIf="attachment.extension !== 'pdf'">
                <img [src]="attachment.fileUrl" alt="" />
                <a (click)="onRemoveRegistrationForm('registration')" class="remove">
                  <i aria-hidden="true" class="far fa-times"></i>
                </a>
              </ng-container>

              <ng-container *ngIf="attachment.extension === 'pdf'">
                <span class="pdf-icon">
                  <i class="far fa-file-pdf"></i>
                </span>
                <a (click)="onRemoveRegistrationForm('registration')" class="remove">
                  <i aria-hidden="true" class="far fa-times"></i>
                </a>
              </ng-container>
            </li>
            <li><a *ngIf="!attachment" (click)="onAddRegistrationForm()">+</a></li>
          </ul>
        </div>
        <span class="attachment-error" *ngIf="showFormErrors && !attachment">Please add signed registration form.</span>
      </div>

      <div class="content-panel">
        <h2>Bank Details Form</h2>
        <div class="expense-add-images">
          <ul class="images">
            <li *ngIf="bankDetailsAttachment">
              <ng-container *ngIf="bankDetailsAttachment.extension !== 'pdf'">
                <img [src]="bankDetailsAttachment.fileUrl" alt="" />
                <a (click)="onRemoveRegistrationForm('bank')" class="remove">
                  <i aria-hidden="true" class="far fa-times"></i>
                </a>
              </ng-container>

              <ng-container *ngIf="bankDetailsAttachment.extension === 'pdf'">
                <span class="pdf-icon">
                  <i class="far fa-file-pdf"></i>
                </span>
                <a (click)="onRemoveRegistrationForm('bank')" class="remove">
                  <i aria-hidden="true" class="far fa-times"></i>
                </a>
              </ng-container>
            </li>
            <li><a *ngIf="!bankDetailsAttachment" (click)="onAddBankDetails()">+</a></li>
          </ul>
        </div>
      </div>

      <div class="content-panel">
        <h2>Miscellaneous Documents</h2>
        <div class="expense-add-images">
          <ul class="images">
            <li *ngFor="let miscAttachment of miscAttachments; let i = index;">
              <ng-container *ngIf="miscAttachment.extension !== 'pdf'">
                <img [src]="miscAttachment.fileUrl" alt="Miscellaneous document" />
                <a (click)="onRemoveRegistrationForm(i.toString())" class="remove">
                  <i aria-hidden="true" class="far fa-times"></i>
                </a>
              </ng-container>

              <ng-container *ngIf="miscAttachment.extension === 'pdf'">
                <span class="pdf-icon">
                  <i class="far fa-file-pdf"></i>
                </span>
                <a (click)="onRemoveRegistrationForm(i.toString())" class="remove">
                  <i aria-hidden="true" class="far fa-times"></i>
                </a>
              </ng-container>
            </li>
            <li><a (click)="onAddMiscAttachment()">+</a></li>
          </ul>
        </div>
      </div>
    </div>

    <button [disabled]="processingRequest || patientRegistrationForm.invalid || !attachment || (subjectIdWarning && !subjectIdWarningAcknowledged)" type="submit" class="btn btn-primary">
      <span *ngIf="processingRequest">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </span>
      <span *ngIf="!processingRequest">Create Patient Registration</span>
    </button>
  </form>

</div>

<app-confirm-action-modal #confirmRemoveAttachmentModal (confirmed)="onConfirmRemoveAttachment($event)"></app-confirm-action-modal>
